import React, { memo } from "react";
import { useSelector } from "react-redux";

import { Button, Image, TopBarOptions } from "../Components";
import Icon from "../assets/icons/Icon";
import { Link } from "react-router-dom";

const Topbar = () => {
  const { user } = useSelector((state) => state.user);

  const handleSideCollapsed = () => {
    const body = document.querySelector("body");
    const currentSize = body.getAttribute("data-sidebar-size");
    if (currentSize && currentSize !== "default") {
      body.setAttribute("data-sidebar-size", "default");
    } else {
      body.setAttribute("data-sidebar-size", "collapsed");
    }
  };

  return (
    <header className="app-header">
      <nav className="nav_header">
        <div className="icon_menu">
          <Button
            className="sidebar-menu-icon men_menu_icon"
            icon="MdMenu"
            onClick={handleSideCollapsed}
          />
          <div className=" logo_img">
            <Link to="/dashboard">
              <Image
                className="logo_icon"
                src="/assets/images/logo.svg"
                alt="logo icon"
                fetchpriority="high"
                loading="eager"
              />
            </Link>
          </div>
        </div>

        {/* <div className="market_box_list">
          <a href="#" className="games-bat text_up">
            SNX : 76,590.47
            <Icon name="FaCaretUp" />
            419.39
          </a>
          <a href="#" className="games-bat text_down">
            NFT : 23,174.45
            <Icon name="FaCaretDown" />
            129.20
          </a>
        </div> */}

        <div className="login_box">
          {/* <div className="notification_box mobile_sett ">
            <Icon name="FaBell" className="icon_new" />
          </div> */}

          {/* <div className="notification_box mobile_sett user-id">
            <Icon name="FaSearch" />
            <div className="profile-hover-main search_card">  <div className="notification_box mobile_sett ">
            <Icon name="FaBell" className="icon_new" />
          </div>
              <Icon name="FaSearch" className="search_icon" />
              <Input
                placeholder="search..."
                type=" text"
                className="searchbar_box"
              />
            </div>
          </div> */}

          <TopBarOptions user={user} />
        </div>
      </nav>
{/* 
      <div className="new_box">
        <span className="icon_new">
          <Icon name="FaVolumeUp" size="15" />
        </span>

        <marquee>Welcome to Report Hub</marquee>
      </div> */}
    </header>
  );
};

export default memo(Topbar);
